import { type RouteLocationRaw, useRouter } from 'vue-router';
import { type Ref, computed, inject, ref } from 'vue';
import { defaultHomeRouteInjectionKey } from '../symbols';
import '../shims';

export function useDefaultHomeRoute(): Ref<RouteLocationRaw> {
    return inject(
        defaultHomeRouteInjectionKey,
        ref('/') as Ref<RouteLocationRaw>
    );
}

export function useHomeRoute() {
    const defaultHomeRoute = useDefaultHomeRoute();

    const { currentRoute, push, resolve } = useRouter();

    const location = computed<RouteLocationRaw>(() =>
        resolve(currentRoute.value.meta.homeRoute ?? defaultHomeRoute.value)
    );

    return {
        location,
        push: () => push(location.value),
    };
}
